import { createAction, props } from '@ngrx/store';

import {
    ReportEditionDetailsApiActionTypes,
    ReportEditionStartRegenerate,
} from 'app/report-details/state/models';
import { ReportEditionState } from 'app/shared/report';
import { OperationTimeDto } from 'app/shared/report-template/report-template-adapter/model/template-dto.model';
import { ErrorMessage } from 'shared/error-handling';
import { ReportEditionDetails } from 'shared/report-model';

export const getReportEditionSuccess = createAction(
    ReportEditionDetailsApiActionTypes.getReportEditionSuccess,
    props<{ reportEdition: ReportEditionDetails }>(),
);

export const getReportEditionFailure = createAction(
    ReportEditionDetailsApiActionTypes.getReportEditionFailure,
    props<{ errorMessage: ErrorMessage }>(),
);

export const putRegenerateEditionFailure = createAction(
    ReportEditionDetailsApiActionTypes.putRegenerateEditionFailure,
    props<{
        periodValidationStatus: ReportEditionState;
        reportName: string;
        reportEdition: ReportEditionStartRegenerate;
    }>(),
);

export const putRegenerateEditionSuccess = createAction(
    ReportEditionDetailsApiActionTypes.putRegenerateEditionSuccess,
    props<{
        periodValidationStatus: ReportEditionState;
        reportName: string;
        reportEdition: ReportEditionStartRegenerate;
    }>(),
);

export const getFilterOperationTime = createAction(
    ReportEditionDetailsApiActionTypes.getFilterOperationTime,
    props<{ siteId: string }>(),
);

export const getFilterOperationTimeSuccess = createAction(
    ReportEditionDetailsApiActionTypes.getFilterOperationTimeSuccess,
    props<{ filterOperationTime: OperationTimeDto }>(),
);

export const getFilterOperationTimeFailure = createAction(
    ReportEditionDetailsApiActionTypes.getFilterOperationTimeFailure,
    props<{ errorMessage: ErrorMessage }>(),
);
